import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { SalesGateway } from "../SalesStatistics/SaleRecord.ts";
import { HeyLightOrderStatus } from "../../HeyLight/heyLightOrderDTO.ts";
import { OrdersListPage } from "../OrdersList/OrdersListPage.tsx";
import { useOrdersListUrlState } from "../OrdersList/useOrdersListUrlState.ts";
import { useGetAllHeyLightOrders } from "./useGetAllHeyLightOrders.ts";
import { toOrdersExportApiParams } from "../OrdersList/OrdersListQuery.ts";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { downloadCsvFile } from "../../UI/Utils/downloadCsvFile.ts";
import { AdminHeyLightOrderTable } from "./AdminHeyLightOrderTable.tsx";

const HEYLIGHT_ORDER_STATUSES = Object.values(HeyLightOrderStatus);

export function HeyLightOrdersListScreen({ readOnly }: { readOnly?: boolean }) {
  const { query, setSearch, setSort, setFilters, toPage } =
    useOrdersListUrlState(HEYLIGHT_ORDER_STATUSES);
  const { orders, total, isLoading, error } = useGetAllHeyLightOrders(query);
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();

  if (isLoading) return <FullPageLoading />;

  return (
    <OrdersListPage
      title="Ordini HeyLight"
      searchPlaceholder="Cerca per cliente, partecipanti, ID ordine, ID HeyLight, importo o P.IVA"
      query={query}
      total={total}
      hasError={!!error}
      statisticsGateway={readOnly ? undefined : SalesGateway.HeyLight}
      onSearch={setSearch}
      onClearFilters={() => setFilters({})}
      onChangePage={toPage}
      csvExport={
        readOnly
          ? undefined
          : {
              allOrdersDescription: "tutti gli ordini HeyLight",
              download: () =>
                downloadCsvFile(createAxiosInstance(), {
                  url: "/admin/orders/export/csv",
                  params: toOrdersExportApiParams(query),
                  fileNamePrefix: "ordini-heylight",
                }),
            }
      }
    >
      <AdminHeyLightOrderTable
        orders={orders}
        readOnly={readOnly}
        query={query}
        onSort={setSort}
        onFiltersChange={setFilters}
      />
    </OrdersListPage>
  );
}
